import React from "react";
import NavBar from "../../Layout/Navbar";
// import Section from "./Section";
import HeaderSection from "../../components/HeaderSection";

const PrivacyPolicy = () => {
  return (
    <React.Fragment>
      <NavBar isDark={false} />
      {/* import Section */}
      {/* <Section /> */}
      <HeaderSection 
            title='Privacy Policy'
            subtitle={`Citra Solutions - ${new Date().getFullYear()}`}
        />   
        <section className="blog-post">
            <p>Citra Solutions is committed to providing you with the best possible customer service experience. Citra Solutions is bound by the Privacy Act 1988 (Cth), which sets out a number of principles concerning the privacy of individuals.</p>
        
            <h6>Collection of your personal information</h6>
            
            <p>There are many aspects of the site which can be viewed without providing personal information, however, for access to future Citra Solutions customer support features you are required to submit personally identifiable information. This may include but not limited to a unique username and password, or provide sensitive information in the recovery of your lost password.</p>
            
            <h6>Sharing of your personal information</h6>
            
            <p>We may occasionally hire other companies to provide services on our behalf, including but not limited to handling customer support enquiries, processing transactions or customer freight shipping. Those companies will be permitted to obtain only the personal information they need to deliver the service. Citra Solutions takes reasonable steps to ensure that these organisations are bound by confidentiality and privacy obligations in relation to the protection of your personal information.</p>
            
            <h6>Use of your personal information</h6>
            
            <p>For each visitor to reach the site, we expressively collect the following non-personally identifiable information, including but not limited to browser type, version and language, operating system, pages viewed while browsing the Site, page access times and referring website address. This collected information is used solely internally for the purpose of gauging visitor traffic, trends and delivering personalized content to you while you are at this Site.</p>
            
            <p>From time to time, we may use customer information for new, unanticipated uses not previously disclosed in our privacy notice. If our information practices change at some time in the future we will use for these new purposes only, data collected from the time of the policy change forward will adhere to our updated practices.</p>
            
            <h6>Changes to this Privacy Policy</h6>
            
            <p>Citra Solutions reserves the right to make amendments to this Privacy Policy at any time. If you have objections to the Privacy Policy, you should not access or use the Site.</p>
            
            <h6>Accessing Your Personal Information</h6>
            
            <p>You have a right to access your personal information, subject to exceptions allowed by law. If you would like to do so, please let us know. You may be required to put your request in writing for security reasons. Citra Solutions reserves the right to charge a fee for searching for, and providing access to, your information on a per request basis.</p>
            
            <h6>Contacting us</h6>
            
            <p>Citra Solutions welcomes your comments regarding this Privacy Policy. If you have any questions about this Privacy Policy and would like further information, please contact us by any of the following means during business hours Monday to Friday.</p>
            
            <p>E-mail: info@CitraSolutions.com</p>
        </section>   
    </React.Fragment>
  );
};

export default PrivacyPolicy;
